/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { DocUploadProps } from "./doc-upload.types";
import { DocUploadView } from "./doc-upload-view";
import { useDocUpload } from "./use-doc-upload";

export const DocUpload = ({ requiredDocument, isUSPerson, onFinish }: DocUploadProps) => {
  const logic = useDocUpload({ requiredDocument, onFinish });
  return <DocUploadView requiredDocument={requiredDocument} isUSPerson={isUSPerson} onFinish={onFinish} {...logic} />;
};
